import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/index.vue'
import Product from '@/views/Product/index.vue'
import Price from '@/views/price/index.vue'
import Download from '@/views/down/index.vue'
import About from '@/views/about/index.vue'
import { updatePageSEO } from '@/utils/seo-fallback'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/product', name: 'Product', component: Product },
    { path: '/price', name: 'Price', component: Price },
    { path: '/download', name: 'Download', component: Download },
    { path: '/down', name: 'Download', component: Download },
    { path: '/about', name: 'About', component: About }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

// 路由切换时更新SEO信息
router.afterEach((to) => {
  // 延迟执行，确保页面已经渲染
  setTimeout(() => {
    updatePageSEO(to.path)
  }, 100)
})

export default router